// extracted by mini-css-extract-plugin
module.exports = {"authLink":"authLink--2k1OR","authBtnBox":"authBtnBox--UV89e","timerBox":"timerBox--fq7Fh","input":"input--mpgll","notice":"notice--6B0Yd"};